import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CircularSliderHandleDirective } from './directives/circular-slider-handle.directive';

@NgModule({
    declarations: [
        CircularSliderHandleDirective
    ],
    exports: [
        CircularSliderHandleDirective
    ],
    imports: [
        CommonModule
    ]
})
export class CircularSliderModule {
}
